import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'È cartaceo o digitale?',
  a: "È un prodotto 100% digitale consegnato in formato PDF di alta qualità e file editabili. Puoi accedervi da computer, tablet o smartphone immediatamente dopo l'acquisto."
}, {
  q: 'Ho bisogno di esperienza con gli adulti maggiori?',
  a: 'No. Il sistema è la base ideale sia per i nuovi professionisti che hanno bisogno di struttura, sia per gli istruttori esperti che vogliono ottimizzare il tempo e standardizzare la qualità delle lezioni.'
}, {
  q: 'Funziona per le lezioni di gruppo?',
  a: 'Assolutamente sì. Tutto il sistema è progettato per funzionare sia in sessioni individuali che in classi di gruppo con partecipanti di livelli diversi.'
}, {
  q: 'Posso usarlo in centri anziani, palestre e associazioni sportive?',
  a: 'Sì. Gli strumenti di valutazione, le schede di esercizi e i sistemi di documentazione sono perfettamente adattabili a palestre, centri per anziani, associazioni sportive e servizi di attività motoria adattata.'
}, {
  q: 'Quanto velocemente vedrò i risultati?',
  a: 'La maggior parte degli istruttori riferisce di sentirsi significativamente più organizzata e sicura prima di entrare in sala già dal primo giorno di utilizzo del sistema.'
}, {
  q: 'Gli esercizi sono sicuri per tutti i livelli di mobilità?',
  a: 'Sì. Ogni esercizio include regressioni, progressioni e adattamenti specifici per i diversi livelli di mobilità, equilibrio e forza degli adulti maggiori.'
}, {
  q: 'È un pagamento unico o un abbonamento?',
  a: 'È un pagamento unico. Paghi una volta sola e accedi a tutto il sistema per sempre, senza costi ricorrenti o abbonamenti.'
}, {
  q: 'Posso stampare i materiali?',
  a: 'Sì. Tutti i modelli, le schede, le checklist e i materiali sono progettati per essere stampati e utilizzati direttamente in sala o in ufficio.'
}, {
  q: 'Avrò accesso ai bonus immediatamente?',
  a: "Sì. Tutti i 5 bonus sono inclusi nello stesso accesso immediato che ricevi dopo l'acquisto, senza attese e senza passaggi extra."
}, {
  q: 'Qual è il processo di rimborso se non sono soddisfatto?',
  a: "Semplice. Contattaci entro 7 giorni dall'acquisto e ti rimborseremo il 100% del tuo denaro, senza domande e senza complicazioni."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 px-4 sm:px-6 bg-ivory" data-id="element-38">
      <div className="text-center mb-8" data-id="element-39">
        <h2 className="text-2xl sm:text-4xl font-heading font-bold text-petrol mb-2 leading-tight uppercase" data-id="element-40">
          Domande Frequenti
        </h2>
      </div>

      <div className="flex flex-col gap-3 max-w-3xl mx-auto" data-id="element-41">
        {faqs.map((faq, i) => <div key={i} className="bg-cream border border-gold/30 rounded-lg overflow-hidden shadow-sm" data-id="element-42">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gold/5 transition-colors gap-4" data-id="element-43">
              <span className="font-bold text-petrol text-base sm:text-lg leading-tight font-body" data-id="element-44">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-sage transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-45" />
            </button>

            {openIndex === i && <div className="px-5 pb-5 pt-0 text-graphite text-sm sm:text-base leading-relaxed" data-id="element-46">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}